import React from 'react';
import './Services.scss';
import { LuCalculator } from "react-icons/lu";
import { HiOutlineDocumentMagnifyingGlass } from "react-icons/hi2";
import { FaMoneyBillTrendUp, FaHandsHoldingChild  } from "react-icons/fa6";


export default function Services() {
  const serviciosData = [
    {
      id: 1,
      icono: <LuCalculator />, 
      titulo: "Contabilidad",
      descripcion: "Llevamos tu contabilidad de forma precisa y oportuna cumpliendo con todas tus obligaciones fiscales.",
      features: ["Contabilidad mensual", "Declaraciones fiscales", "Estados financieros", "Cumplimiento SAT"]
    },
    {
      id: 2,
      icono: <HiOutlineDocumentMagnifyingGlass />,
      titulo: "Auditoría",
      descripcion: "Revisamos y evaluamos la información financiera de tu empresa para garantizar transparencia y cumplimiento.",
      features: ["Auditoría financiera", "Auditoría fiscal", "Dictámenes", "Control interno"]
    },
    {
      id: 3,
      icono: <FaMoneyBillTrendUp />,
      titulo: "Finanzas",
      descripcion: "Te ayudamos a tomar mejores decisiones financieras para mejorar la rentabilidad y el crecimiento de tu negocio.",
      features: ["Planeación financiera", "Análisis de resultados", "Presupuestos", "Proyecciones"]
    },
    {
      id: 4,
      icono: <FaHandsHoldingChild />,
      titulo: "Asesoría para pensiones del IMSS",
      descripcion: "Asesoría especializada para que tu empresa y tus colaboradores cumplan y aprovechen al máximo sus beneficios en el IMSS.",
      features: ["Cálculo de pensión", "Modalidades de pensión", "Corrección de semanas", "Asesoría personalizada"]
    }
  ];

  return (
    <section className="services-section">
      {/* ENCABEZADO DE LA SECCIÓN */}
      <div className="services-header">
        <span className="services-subtitle">SERVICIOS</span>
        <h2 className="services-title">
          Soluciones contables y financieras <br />
          para hacer crecer tu empresa
        </h2>
        <p className="services-description">
          Ofrecemos servicios especializados que se adaptan a las necesidades <br />
          de tu negocio, con enfoque fiscal, financiero y estratégico.
        </p>
      </div>

      {/* CUADRÍCULA DE TARJETAS */}
      <div className="services-grid">
        {serviciosData.map((servicio) => (
          <div key={servicio.id} className="service-card">
            <div className="service-icon">{servicio.icono}</div>
            <h3 className="service-card-title">{servicio.titulo}</h3>
            <div className="card-divider"></div>
            <p className="service-card-desc">{servicio.descripcion}</p>
            
            {/* Lista con palomitas */}
            <ul className="service-features-list">
              {servicio.features.map((feature, index) => (
                <li key={index}>
                  <span className="checkmark">✓</span> {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* ENLACE DE ABAJO */}
      <div className="services-footer">
        <a href="#todos-los-servicios" className="services-link">
          <span className="link-icon"></span> Conoce todos nuestros servicios <span className="arrow">→</span>
        </a>
      </div>
    </section>
  );
}